import request from './request'

// 获取排队信息
export function getQueueState(hospId) {
    return request.get('/api/queue/state', {
        params: {
            hospId
        }
    })
}